import { render, staticRenderFns } from "./product-card-meb.vue?vue&type=template&id=22fffd6e&scoped=true&"
import script from "./product-card-meb.vue?vue&type=script&lang=js&"
export * from "./product-card-meb.vue?vue&type=script&lang=js&"
import style0 from "./product-card-meb.vue?vue&type=style&index=0&id=22fffd6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fffd6e",
  null
  
)

export default component.exports